"use client";

// Disable static generation for this page since it uses client-side React Query hooks
export const dynamic = "force-dynamic";

export default function NotFound() {
  return (
    <div style={{ padding: 40, textAlign: "center" }}>
      <h1>404 – Not Found</h1>
    </div>
  );
}
